import { render, staticRenderFns } from "./emailSignature.vue?vue&type=template&id=7a510af5&"
import script from "./emailSignature.vue?vue&type=script&lang=js&"
export * from "./emailSignature.vue?vue&type=script&lang=js&"
import style0 from "./emailSignature.vue?vue&type=style&index=0&id=7a510af5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports